import type { Paginated } from '@oxxean/types';
import { http } from '../http';

/**
 * Personas que marcan asistencia y no existen en BUK.
 *
 * Es una CONCILIACIÓN entre dos orígenes, no un indicador: mide la distancia entre
 * lo que dice ctrl iT y lo que dice BUK. Por eso vive bajo `/sync`.
 */

export interface UnidentifiedPerson {
  /** RUT tal como lo entrega ctrl iT, normalizado. */
  normalizedDni: string;
  marks: number;
  firstMark: string;
  lastMark: string;
  /** Recintos donde marcó. Más de uno indica que se mueve entre faenas. */
  venues: string[];
  /**
   * Empresas dueñas de esos recintos.
   *
   * NO es su empleador: precisamente lo que no se sabe es para quién trabaja.
   */
  companies: string[];
}

export interface UnidentifiedSummary {
  totalPeople: number;
  totalMarks: number;
  /** Todas las marcaciones del ámbito, para expresar la proporción. */
  allMarks: number;
  byCompany: Array<{
    company: string;
    people: number;
    marks: number;
    firstMark: string;
    lastMark: string;
  }>;
}

export async function fetchUnidentifiedSummary(): Promise<UnidentifiedSummary> {
  const response = await http.get<UnidentifiedSummary>('/sync/attendance/unidentified/summary');
  return response.data;
}

export async function fetchUnidentified(params: {
  page: number;
  pageSize: number;
  search?: string;
}): Promise<Paginated<UnidentifiedPerson>> {
  const response = await http.get<Paginated<UnidentifiedPerson>>(
    '/sync/attendance/unidentified',
    { params },
  );
  return response.data;
}
